import { ampli } from '~/third-party/ampli/.client';
import { RudderAnalytics } from '@rudderstack/analytics-js';
import { SentryClient } from '~/lib/sentry.client';

export const rudderAnalytics = new RudderAnalytics();
const DATA_PLANE_URL = 'https://flpmaxeymaooih.dataplane.rudderstack.com';

// Flag to ensure we only patch once
let isPatched = false;

type AnalyticsInitArgs = {
  rudderstackWriteKey: string;
  envName: string;
};
export function analyticsInit({ rudderstackWriteKey, envName }: AnalyticsInitArgs) {
  if (!rudderstackWriteKey) {
    if (envName !== 'preview') {
      SentryClient.captureMessage('Missing rudderstackWriteKey', { level: 'warning' });
    }
    return;
  }

  rudderAnalytics.load(rudderstackWriteKey, DATA_PLANE_URL, {
    useBeacon: true,
  });

  // Monkey patch ampli.track to send to RudderAnalytics after both services are loaded
  if (!isPatched) {
    ampli.track = function (...args: Parameters<typeof ampli.track>) {
      const [event] = args;
      rudderAnalytics.track(
        event.event_type,
        event.event_properties as Record<string, string | number>
      );

      return { promise: Promise.resolve() };
    };
    isPatched = true;
  }

  if (globalThis.ENVIRONMENT !== 'production') {
    // Identify the env so it can be filtered in the staging project
    rudderAnalytics.identify({ env: 'vega' });
  }
}
